import { createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {apiUrl} from '../config'
import cogoToast from "cogo-toast";

const getToken = () => {
  const token = localStorage.getItem("token");
  return token;
};

export const getNotifications = createAsyncThunk(
  'getNotifications',
  async (arg, {rejectWithValue, dispatch, getState}) => {
    try {
      const res = await axios.get(
        `${apiUrl}notifications/unread`,
        {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${getToken()}`
          }, 
        }
      )
      if(res.status === 200){
          return res.data
      }
      
    } catch (error) {
      if(error.response.status === 401){
        dispatch({type: 'auth/Logout'})
      }
      else{
        return rejectWithValue(error.response)
      }
    }
  }
)

export const markSpecificNotification = createAsyncThunk(
  'markSpecificNotification',
  async ({ id }, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await axios.post(
        `${apiUrl}notifications/${id}/mark-as-read`,
        "",
        {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${getToken()}`
          }, 
        }
      )
      console.log(res)
      if(res.status === 200){
        cogoToast.success("Notification marked successfully!", {
          position: "top-right",
          });
          return res.data
      }
    } catch (error) {
      // return custom error message from API if any
      if(error.response.status === 401){
        dispatch({type: 'auth/Logout'})
      }
      else{
        return rejectWithValue(error.response)
      }
    }
  }
)


